exports.onRouteUpdate = function ({ prevLocation }, pluginOptions) {
  
};